import { render, staticRenderFns } from "./aboutus.vue?vue&type=template&id=8a3519e4&scoped=true&"
import script from "./aboutus.vue?vue&type=script&lang=js&"
export * from "./aboutus.vue?vue&type=script&lang=js&"
import style0 from "./aboutus.vue?vue&type=style&index=0&id=8a3519e4&lang=scss&scoped=true&"
import style1 from "./aboutus.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3519e4",
  null
  
)

export default component.exports